export default __webpack_public_path__ + "static/media/left-side.9843482c.png";